// extracted by mini-css-extract-plugin
module.exports = {"root":"logo-module--root--3bBqJ","firstRow":"logo-module--first-row--3-Wui","secondRow":"logo-module--second-row--2iQwT"};